module.exports = __webpack_public_path__ + "static/media/animated_samuel.ef4293c4.png";